var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.0002C14.341 10.0002 15.8334 8.50778 15.8334 6.66683C15.8334 4.82588 14.341 3.3335 12.5 3.3335C10.6591 3.3335 9.16669 4.82588 9.16669 6.66683C9.16669 8.50778 10.6591 10.0002 12.5 10.0002Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.6668C12.5 16.6668 19.1666 16.6668 19.1666 15.0002C19.1666 13.0002 15.9166 10.8335 12.5 10.8335C9.08331 10.8335 5.83331 13.0002 5.83331 15.0002C5.83331 16.6668 12.5 16.6668 12.5 16.6668Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 8.3335V5.8335H3.33331V8.3335H0.833313V10.0002H3.33331V12.5002H4.99998V10.0002H7.49998V8.3335H4.99998Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersmall);
export default __webpack_public_path__ + "static/media/usersmall.1f4780fb343d19a80ea7b26212020db8.svg";
export { ForwardRef as ReactComponent };